/** File extensions supported by upload forms */

type Ext = `.${string}`

export const lossyImageExtensions: ReadonlyArray<Ext> = ['.jpg', '.jpeg', '.webp']
export const losslessImageExtensions: ReadonlyArray<Ext> = ['.gif', '.png']

/** Note: Some platforms have (security) issues with .svg, e.g. WP */
export const vectorImageExtensions: ReadonlyArray<Ext> = ['.svg']
export const bitmapFileExtensions: ReadonlyArray<Ext> = [...lossyImageExtensions, ...losslessImageExtensions]
/**
 * Logo uploads. Every logo field accepts the same set: the four logo fields (onboarding and the
 * Brandfetch dialog, organization settings, the campaign logo override, the custom survey header)
 * used to disagree on svg and webp, which shipped as bugs both ways. Svg is safe here because a
 * logo is only ever rendered through `<img>`, where svg scripts do not run, and the stored object
 * carries `Content-Disposition: attachment` so it cannot be opened as a document either.
 */
export const logoFileExtensions: ReadonlyArray<Ext> = [...bitmapFileExtensions, ...vectorImageExtensions]
export const videoFileExensions: ReadonlyArray<Ext> = ['.mov', '.mp4', '.webm', '.mpeg', '.m4v']
export const browserSafeImageExtensions: ReadonlyArray<Ext> = ['.jpg', '.png', '.gif', '.webp']

// Specific file formats
export const wordFileExtensions: ReadonlyArray<Ext> = ['.doc', '.docx']
export const csvFileExtensions: ReadonlyArray<Ext> = ['.csv']
export const excelFileExtensions: ReadonlyArray<Ext> = ['.xls', '.xlsx']
export const tableFileExtensions: ReadonlyArray<Ext> = [...csvFileExtensions, ...excelFileExtensions]
export const powerpointFileExtensions: ReadonlyArray<Ext> = ['.ppt', '.pptx']
export const pdfFileExtensions: ReadonlyArray<Ext> = ['.pdf']
export const photoshopFileExtensions: ReadonlyArray<Ext> = ['.psd']
export const illustratorFileExtensions: ReadonlyArray<Ext> = ['.ai', '.esp']

// TODO: Is it safe to put the above here?
export const binaryFileExtensions: ReadonlyArray<Ext> = [
  '.doc',
  '.docx',
  '.pdf',
  '.xls',
  '.xlsx',
  '.csv',
  '.txt',
  '.zip',
]
